module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-23.a4715788.jpg";